export const PAGE_URL = {
  LOGIN: "/",
  RESET_PASSWORD: "/reset-password",
  RESET_PASSWORD_SUCCESS: "/reset-password-success",
  CREATE_PASSWORD: "/create-password",
  CREATE_PASSWORD_SUCCESS: "/create-password-success",
  DASHBOARD: "/dashboard",
  REDIRECTION: "/redirect",
  SETTINGS: "/settings",
  STATUS: "/analysis",
  CALL_INSIGHTS: "/call-insights",
  CALLS_DATA: "/calls-data"
};

export const PAGE_TITLE = [
  {
    route: PAGE_URL.REDIRECTION,
    title: "Authentication",
    displayBackButton: false,
  },
  {
    route: PAGE_URL.DASHBOARD,
    title: "Call insights dashboard",
    displayBackButton: false,
  },
  {
    route: PAGE_URL.CALL_INSIGHTS,
    title: "Call insights",
    displayBackButton: true,
  },
  {
    route: PAGE_URL.CALLS_DATA,
    title: "Call data",
    displayBackButton: false,
  },
];
